import agreement1 from '@/locales/Terms/FranchiseAgreement/US/agreement1.html';
import agreement2 from '@/locales/Terms/FranchiseAgreement/US/agreement2.html';
import agreement3 from '@/locales/Terms/FranchiseAgreement/US/agreement3.html';
import agreement4 from '@/locales/Terms/FranchiseAgreement/US/agreement4.html';
import agreement5 from '@/locales/Terms/FranchiseAgreement/US/agreement5.html';
import agreement6 from '@/locales/Terms/FranchiseAgreement/US/agreement6.html';
import agreement7 from '@/locales/Terms/FranchiseAgreement/US/agreement7.html';
import agreement8 from '@/locales/Terms/FranchiseAgreement/US/agreement8.html';
import agreement9 from '@/locales/Terms/FranchiseAgreement/US/agreement9.html';
import agreement10 from '@/locales/Terms/FranchiseAgreement/US/agreement10.html';
import agreement11 from '@/locales/Terms/FranchiseAgreement/US/agreement11.html';
import agreement12 from '@/locales/Terms/FranchiseAgreement/US/agreement12.html';
import agreement13 from '@/locales/Terms/FranchiseAgreement/US/agreement13.html';
import guideline1 from '@/locales/Terms/Guideline/US/guideline1.html';
import guideline2 from '@/locales/Terms/Guideline/US/guideline2.html';
import legal_indication1 from '@/locales/Terms/LegalIndication/US/legal_indication1.html';
import legal_indication2 from '@/locales/Terms/LegalIndication/US/legal_indication2.html';
import legal_indication3 from '@/locales/Terms/LegalIndication/US/legal_indication3.html';
import legal_indication4 from '@/locales/Terms/LegalIndication/US/legal_indication4.html';
import legal_indication5 from '@/locales/Terms/LegalIndication/US/legal_indication5.html';
import legal_indication6 from '@/locales/Terms/LegalIndication/US/legal_indication6.html';
import legal_indication7 from '@/locales/Terms/LegalIndication/US/legal_indication7.html';
import legal_indication8 from '@/locales/Terms/LegalIndication/US/legal_indication8.html';
import privacy_policy1 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy1.html';
import privacy_policy2 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy2.html';
import privacy_policy3 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy3.html';
export default {
	locale_order: 2,
	locale_name: 'English',
	terms: {
		title: 'ONETETHER Terms of Service',
		agreement1,
		agreement2,
		agreement3,
		agreement4,
		agreement5,
		agreement6,
		agreement7,
		agreement8,
		agreement9,
		agreement10,
		agreement11,
		agreement12,
		agreement13,
		guideline1,
		guideline2,
		legal_indication1,
		legal_indication2,
		legal_indication3,
		legal_indication4,
		legal_indication5,
		legal_indication6,
		legal_indication7,
		legal_indication8,
		privacy_policy1,
		privacy_policy2,
		privacy_policy3,
		menu: {
			category1: 'The Franchise Agreement',
			title1: 'Merchant Terms and Conditions (for online payment)',
			title2: 'Online payment API Usage Special Agreement',
			title3: 'Balance Terms and Conditions (for online payment)',
			title4:
				'Credit Card Merchant Terms and Conditions (for mail-order merchants)',
			title5:
				'ONETETHER for Business Terms and Conditions (for online payment)',
			title6: 'Postpaid Merchant Terms and Conditions (for online payment)',
			title7: 'Data Usage Special Agreement',
			title8: 'Special Agreement on Payment for Products, etc.',
			title9: 'Special Agreement on the Handling of prepaid services',
			title10: 'Merchant Terms and Conditions (for mini-app)',
			title11: 'Data Use Special Agreement (for mini app)',
			title12: 'The establishment of a contract',
			title13: 'About Joint Use of Merchant Information',
			category2: 'The Guideline',
			title14: 'Merchant Guidelines (for Mini-app)',
			title15: 'Merchant Guidelines (for online payments)',
			category3: 'Legal Indication',
			title16: 'Banking Agent Overview',
			title17: 'Handling product card loan individual interest rate, etc',
			title18: 'Handling product Card loan Individual product brief',
			title19: 'Yen ordinary deposit account interest rate, etc',
			title20: 'Yen ordinary deposit account product overview',
			title21: 'Handling product business loan interest rate, etc',
			title22: 'Handling product Business loan Product brief',
			title23:
				'About the applicable interest rate in case of multiple contracts with the Company',
			category4: 'Privacy Policy',
			title24: 'Request for disclosure of personal information',
			title25: 'About User Security',
			title26: 'Affiliated company',
		},
	},
	cookies: {
		title: 'Cookies Usage Policy',
		text1:
			'ONETETHER uses cookies to anonymously collect search information from website users to obtain sources and other statistics.',
		text2:
			"Cookies are tiny text files on your computer's hard disk, for example, for recording the process of purchasing a product, search propensity, activity, and so on.",
		text3: 'In particular, it is used as follows:',
		text4:
			'Google Analytics. Google can use this information to improve its services and provide services to third parties.',
		text5: 'All information can be accessed via the following link.',
		text6: 'Protect data',
		text7: 'Analytics Blocking Browser Add-On',
		text8:
			'The tool does not collect your name, address, and access information. The information about users collected is related to, for example, the number of access sites, the language of use, the city displayed by the user IP, the number of visitors, the number of revisits, the time of access, the browser, operator, or terminal type used. The above information is used to identify new requirements and to provide better website service to users through evaluation of improvement efforts.',
		text9:
			'Cookies used on social networks. This website has a social network button installed to allow users to share their content of interest with social groups. Cookies stored through social networks prevent the inconvenience of re-entering personal information in sharing the above content.',
		text10:
			'Tools options in the web browser installed on your computer allow you to allow/disallow all cookies, delete them, or go through verification whenever cookies are saved.',
		text11:
			'You can find functional information for each web browser you use at the link below:',
		text12: 'Firefox',
		text13: 'Chrome',
		text14: 'Safari',
	},
	rtr_home: {
		text1: 'Do you still think it is',
		text2: 'impossible to pay with',
		text3: 'cryptographic assets?',
		text4:
			'Payments can be made immediately without exchanging cryptographic assets',
		button1: 'Cryptographic assets pay immediately',
		text5: 'ONETETHER, safety and speed',
		text6: 'at the same time',
		text7: 'Meet the fastest payment system with the stability',
		text8: "of the blockchain and ONETETHER's unique technology.",
		text9: 'Sign Up',
		text10: 'We offer it',
		text11: 'for free.',
		text12: 'The best technology, the best service, and the best platform',
		text13: 'but ONETETHER is free.',
		text14: 'How to create a free account',
		text15: 'With ONETETHER, there are',
		text16: 'so many advantages.',
		text17: "ONETETHER doesn't need a credit card.",
		text18: 'As long as you’re connected to wifi network,',
		text19: 'you can use ONETETHER anywhere.',
		text20: 'You can pay immediately through QR code.',
		text21: 'You can also pay offline through',
		text21_1: 'kiosks and POS machines.',
		text22: 'How to shop and pay',
		text23: 'ONETETHER Payment',
		text24: 'Pay anywhere',
		text25: 'QR code Payment',
		text26: 'Easy payment with QR code',
		text27: 'Kiosk and POS Machine',
		text28: 'Convenient offline payment',
		text29: 'It can be used anywhere in the world.',
		text30: 'Anyone can use it and it can be used anywhere.',
		text31: 'ONETETHER knows the biggest attraction of cryptographic assets.',
		text32:
			"We're trying to be a guide to telling the world how to use cryptographic assets.",
		button2: 'Getting Started for Free',
		text33: 'Even business members',
		text34: 'can use for free.',
		text35: 'Are you looking for ways to expand your business?',
		text36: 'Do you still pay with currency pair?',
		text37:
			"Get paid with cryptographic assets used by the world's population.",
		text38: 'Opening a business store',
		text39: 'We',
		text40: 'hear your voice.',
		text41: 'ONETETHER always listens to customer’s',
		text42: 'and practices them.',
		text43: 'Q&A',
	},
	'rtr_personal-how-online_shopping': {
		title1: 'Pay with ONETETHER',
		text1: 'Add the cryptocurrency you want and',
		text2: 'experience shopping flexibly wherever you want.',
		text3: 'cryptocurrency that is only in your electronic wallet',
		text4: 'ONETETHER ',
		text5: 'through',
		text6: 'Enjoy shopping anywhere with.',
		text7: 'Make a cryptocurrency',
		text8: 'wallet that you want in ONETETHER.',
		text9: 'Please choose',
		text10: 'ONETETHER when you are shopping.',
		text11: 'Pay with the cryptocurrency',
		text12: 'you want on ONETETHER.',
		title2: 'We hope you',
		title3: 'enjoy it again.',
		text13: 'Please buy with ONETETHER,',
		text14: 'get points and then buy again.',
		text15: 'ONETETHER points are available',
		text16: 'at all Merchants using ONETETHER.',
		title4: 'Pay',
		title5: 'without worrying.',
		text17: "ONETETHER's security is the best in the world.",
		text18: 'We keep your cryptocurrency and assets safe and',
		text19: 'help you use them safely.',
	},
	'rtr_personal-how-offline_kiosk': {
		title1: 'How to use',
		title2: 'offline merchants',
		text1: 'Customers can quickly make payments themselves.',
		text2: 'Please try ONETETHER, which allows you to pay immediately with a',
		text3: 'mobile phone without cash or card.',
		text4: 'ONETETHER ',
		text5: 'Payment method using',
		text6: 'Select ONETETHER',
		text7: 'on your phone and use it.',
		text8: 'Select your wallet',
		text9: 'and then select the Offline Store Payment.',
		text10: 'If you scan the QR code on the kiosk,',
		text11: 'the payment is complete.',
		text12: 'Welcome to the ',
		text13: 'future currency system.',
		text14: 'Secure Payment',
		text15:
			'Your information will not be remembered when you make an offline payment.',
		text16: 'At a nearby merchants',
		text17: 'Find merchants with ONETETHER anytime, anywhere and use it.',
		text18: 'Without cash',
		text19: 'Do you still carry cash? Use ONETETHER on your phone right away.',
		title3: 'Sellers can',
		title4: 'access easily too.',
		text20:
			'All you have to do is register the items for sale at the ONETETHER kiosk.',
		text21: 'The payment will be made by ONETETHER Kiosk.',
	},
	'rtr_personal-how-qr': {
		title1: 'Pay at your go-to store',
		title2: 'with ONETETHER.',
		text1: 'Paying directly is as easy as scanning QR codes',
		text2: 'when paying and does not require touch.',
		text3: "You don't have to carry cards or cash, just use the app.",
		text4: 'Welcome to the future currency system.',
		text5: 'Secure Payment',
		text6: 'ONETETHER does not disclose your',
		text7: 'information during QR code transactions.',
		text8: 'Any company',
		text9: 'Pay at the',
		text10: 'offline merchants anywhere,',
		text11: '24 hours a day.',
		text12: 'Touch-free, no cash',
		text13: "Don't worry about cash or",
		text14: 'credit card- open the application and pay.',
		text15: '3-steps payment with QR code',
		text16: 'You need ONETETHER',
		text17: 'app and account.',
		text18: 'STEP 01. Scan or Show',
		text19: 'STEP 02. Payment',
		text20: 'STEP 03. Confirm',
		text21: 'Tap the QR iPhone,',
		text22: 'select Scan when the seller presents the code,',
		text23: 'or tap Show to pay if you are requesting a QR code.',
		text24: 'Scan the code when the QR code is displayed',
		text25:
			'Once you receive the payment confirmation, all payments will be completed.',
		title3: 'Prepare for sale',
		title4: 'with QR code.',
		text26: 'Whether you start or run your business,',
		text27: 'you can easily accept touch-free face-to-face payments',
		text28: 'without hardware, software or card readers.',
		text29: 'STEP 01.',
		text30: 'Scan or Show',
		text31: 'STEP 02.',
		text32: 'Payment',
		text33: 'STEP 03.',
		text34: 'Confirm',
	},
	'rtr_personal-how-janopay_creditcard': {
		title1: 'ONETETHER card',
		text1: 'You can easily access your ONETETHER balance',
		text2: 'with debit and prepaid cards or fund your daily purchases',
		text3: 'with one of your credit offerings.',
		title2: 'ONETETHER Credit',
		title3: 'Buy now and pay over time.',
		text4: 'Get special financing for purchases over',
		text5: '10,000 yen wherever ONETETHER is allowed.',
		text6: 'There is no interest if you pay the',
		text7: 'full amount within 6 months for every 10,000 yen purchase.',
		text8: 'If you do not pay your balance in full within six months,',
		text9:
			'interest will be charged to your account from the date of purchase.',
		text10: 'A minimum monthly payment is required. Subject to credit approval',
		// text11: '쇼핑 및 구매방법',
		text12: 'Available wherever',
		text13: 'ONETETHER is allowed',
		text14: 'No annual fee',
		text15: 'ONETETHER Coin Access',
		text16: 'from your ONETETHER account',
		title4: 'NEW',
		title5: 'ONETETHER Cashback',
		text17: 'Unlimited 3% cashback when purchasing ONETETHER',
		text18: 'Get unlimited 2% for all other purchases.',
		text19: 'Be the first to find out when you can use it.',
		text20: 'Previous 2% cashback holders do not need to join the list.',
		text21: 'You will receive an automatic upgrade.',
		title6: 'ONETETHER Cash Card',
		text22: 'You can easily manage ',
		text23: 'your funds by accessing them with a',
		text24: 'debit card connected to your ONETETHER balance.',
		text25: 'ONETETHER Cash Card Information',
		text26: 'Learn about ONETETHER Credits',
		text27: 'View Terms and Conditions',
	},
	'rtr_personal-how-trade_and_cashback': {
		title1: 'You can get',
		title2: 'additional rewards by using ONETETHER.',
		text1: 'Save money by transactions,',
		text2: 'cashback offers and promotional code',
		text3: 'and get rewards from the best stores and your favorite brands.',
		title3: 'Trade in cryptocurrency that suits me',
		text4: 'We will showcase deals, products and',
		text5: 'stores you think you will like based on where you shop and buy,',
		text6:
			'and we promise to continue to increase and update your favorite stores.',
		title4: 'Maximize your rewards',
		title5: 'Maximize rewards',
		text7: 'Combining transactions, cashback suggestions and',
		text8: 'promotional code can save you more money.',
		text9: 'We will help you find and apply promotion codes',
		text10: 'when you pay.',
		text11: 'Does ONETETHER card offer a reward?',
		text12: 'Check out for your purchase and use it to get a reward.',
		text13: 'Start shopping',
		title6: 'Secure checkout',
		text14:
			'Utilize transaction and cashback offers from millions of global retailers',
		text15: 'when making payments securely with ONETETHER.',
		text16: 'Your information is encrypted and',
		text17: 'will not be sold or shared without your permission.',
		text18: 'Learn how to protect yourself',
	},
	'rtr_personal-request-send': {
		title1: 'A safe and fun way to',
		title2: 'remittance online',
		text1: "It's a simple way to quickly remit money to family and",
		text2: 'friends from almost anywhere in the world.',
		text3: 'Get the most out of all transfers',
		text4: 'Two-way messages',
		text5: 'Exchange messages to check if',
		text6: 'the payment is correctly',
		text7: 'made between friends.',
		text8: 'Free Options',
		text9: 'After you use the ',
		text10: "ONETETHER point card and check it's balance,",
		text11: 'you can remit money online from overseas.',
		text12: 'Quick Access',
		text13: 'The recipient can',
		text14: 'get the money without delay',
		text15: 'when remitting cryptocurrency.',
		title4: 'Year-Round Monitoring',
		text16: 'With encryption technology, we do our best to',
		text17: 'ensure that your transfer is safe.',
		title5: 'Transfer Worldwide',
		text18: 'Transfer money to your recipient anywhere',
		text19: 'in the world with ONETETHER.',
		text20: 'Transfer money online to friends and family anywhere in the world',
		text21: '0 JPYS',
		text22: 'Transaction fee in ONETETHER',
		text23: 'When withdrawing from wallets from other banks,',
		text24: '0% if money is sent from ONETETHER balance.',
	},
	'rtr_personal-request-receive': {
		title1: 'request conveniently',
		text1: 'Friends and family can',
		text2: 'request cryptocurrency without notification.',
		title2: 'Convenient Asset Request Service',
		text3: 'Convenient, easy-to-use requests',
		text4: 'Instant two-way messaging',
		title3: 'Free request',
		title4: 'service without hassle',
		text5: 'Once you request money from your friends and',
		text6: 'then wait, money will be deposited automatically.',
		title5: 'Easy Settings',
		text7: "If your friend doesn't have a ONETETHER account",
		text8: 'only have to do is sign up in a few minutes.',
		text9: "It's easy to send salaries.",
		text10: 'Open the app and select Receive Payment.',
		title6: 'Select a ONETETHER user and',
		title7: 'enter the requested amount.',
		title8: 'Secure checkout',
		text11: 'You can simplify the daily reception of cryptocurrency by',
		text12: 'instantly creating a link to request assets of ONETETHER.',
		text13: 'Creating a ONETETHER Link',
	},
	'rtr_personal-request-deposit': {
		text1: '입금 받기',
		text2: 'ONETETHER에서 편리하게 입금을 받으세요.',
		text3: '가장 편리한 입금',
		text4: '상대방 이메일로 보내면 끝',
		text5: '받는 사람에게 표시되는 것',
		text6: 'ONETETHER와',
		text7: 'ONETETHER 간의 송금',
		text8: 'ONETETHER에서 ONETETHER로 송금 시',
		text9: '사용되는 계좌번호가 노출됩니다.',
		text10: '외부에서',
		text11: 'ONETETHER로 입금',
		text12: '외부에서 ONETETHER로 입금 시',
		text13: '사용되는 지갑 주소가 노출됩니다.',
	},
	'rtr_personal-request-commission': {
		text1: '송금 수수료 무료',
		text2: 'ONETETHER간의 송금시 수수료 무료!',
		text3: '외부 지갑 입금시',
		text4: '네트워크비용만',
		text5: '입금시 ONETETHER에서는',
		text6: '수수료 지불요청을 하지 않습니다.',
		text7: '자사의플랫폼 내의',
		text8: '이동은 무료입니다.',
		text9: '외부 출금시에만 수수료 발생',
		text10: 'ONETETHER를 이용하여 구입시 수수료 무료',
	},
	'rtr_personal-asset-wallet': {
		text1: '국제 규격 지갑 사용',
		text2: '보안에 보안을 한 자체 지갑',
		text3: '외부 지갑 업체가 아닌 자체 기술력으로 개발한 지갑을 사용합니다.',
		text4: '국제 규격에 맞춘',
		text5: 'LEVEL 2 이상의 보안',
		text6: '한 번 더 보안을 신경써서',
		text7: '해킹을 완벽하게 차단합니다.',
		text8: '개인키가',
		text9: '발생하지 않습니다.',
		text10: '관리자 및 DB 해킹이 들어와도',
		text11: '개인키가 없어서 해킹이 어렵습니다.',
		text12: '지갑이란',
		text13: '고객님의 금고와 같습니다.',
		text14: '저희 ONETETHER는 자체 지갑을 제작 후',
		text15: '보안에 보안을 거듭한 지갑이기에 해킹 대응에',
		text16: '최적화 되어 보안에 자신감을 가지고 있습니다.',
	},
	'rtr_personal-asset-account': {
		text1: 'ONETETHER 独自口座システム',
		text2: '銀行にのみ口座があるのではありません。',
		text3: 'ONETETHER 提供口座で、より便利に',
		text4: '独自口座システムで',
		text5: 'より早く',
		text6: 'ONETETHERからONETETHER口座に送金時',
		text7: '1~3秒内に送金が可能になりました。',
		text8: 'もう待つ必要がありません。',
		text9: '送金システムを作る',
		text10: '口座を利用したONETETHERからONETETHERに送金時',
		text11: '手数料無料、時間短縮が可能',
		text12: 'ONETETHER 口座システムで早い送金',
		text13: '今体験してみてください。',
	},
	'rtr_personal-asset-jpys': {
		text1: 'JPYS 자체 포인트 시스템',
		text2: '빠르고 안전한 자체 포인트 시스템',
		text3: '고정된 환율 제공으로 피곤함이 없다.',
		text4: '모든 시스템과 연동',
		text5: '오프라인 매장 및 온라인 스토어 모두',
		text6: 'JPYS 하나만 있으면 다 됩니다.',
		text7: '키오스크 및 포스기',
		text8: '어디에서나 결제를 자유롭게',
		text9: '편리한 충전',
		text10: '원하는 암호자산 및 신용카드로',
		text11: '즉시 충전이 가능합니다.',
	},
	'rtr_personal-asset-sale': {
		title1: '판매하기',
		text1: '암호자산 판매가 어렵나요?',
		text2: '아직도 구매자를 기다리시나요?',
		title2: '암호자산 판매가',
		title3: '너무 쉬워졌습니다.',
		text3: '고객과 고객간의 판매',
		text4: '고객이 직접 ONETETHER에 판매',
		text5: '선호하는 방법으로 판매하세요.',
		title4: '버튼 한 번으로',
		title5: '환율이 자동 적용',
		text6: '버튼 한 번으로 현재 시세가',
		text7: '자동으로 적용되어 바로 판매가 가능합니다.',
	},
	'rtr_personal-asset-exchange': {
		title1: '은행과 같은 환전',
		text1: '판매 하고 구매 하고',
		text2: '아직도 이쪽 저쪽 다니면서 환전 하시나요?',
		title2: '환전 하고 바로 송금',
		text3: '아직도 암호 자산 구입하고 보내기가 힘드신가요?',
		text4: '은행처럼 사용하세요. 바로 송금 및 출금이 가능합니다.',
		title3: '버튼 한 번으로',
		title4: '쉽게 환전하세요.',
		text5: '자동 환율, 자동 판매',
		text6: '너무 쉬운 인터페이스',
		title5: '원하는 자산과 언제든지',
		text7: '암호 자산과 암호 자산 간의 환전도 가능',
		text8: '암호 자산을 JPYS 포인트로 환전도 가능',
	},
	'rtr_business-how-start': {
		title1: 'Getting Started',
		text1: 'Everything starts with a business account.',
		text2: 'Join over 30 million sellers who rely on ONETETHER.',
		text3: 'Contact account specialist to get started.',
		title2: 'Easy Settings',
		text4: 'Inquiry.',
		text5: "We'll help you.",
		// text6: 'help@janopay.com',
		title3: 'Registration is free.',
		text7: 'You only need an email address and',
		text8: 'some basic information about your business.',
		text9: 'Join a business account',
		title4: 'Start Payment',
		text10:
			'Once you confirm your email address and company name and link your',
		text11: 'ONETETHER account, you complete',
		text12: 'your first sales preparation.',
	},
	'rtr_business-how-receive': {
		title1: 'Accept online and',
		title2: 'Face-to-Face Payments',
		title3: 'Gain a competitive advantage',
		title4: 'Flexibility required by customers',
		title5: 'Connect with global buyers',
		title6: 'Accept Online Payment',
		title7: 'Online Checkout',
		title8: 'Invoice and Estimate',
		title9: 'Sale on Socials',
		title10: 'Online Cryptocurrency Payment System',
		title11: 'Accept Direct Payment',
		title12: 'Point of Sale',
		text1: 'Contact your account specialist to get started.',
		text2: 'We help small businesses to receive payments almost everywhere.',
		text3: 'Have customers pay later, sign up for a subscription,',
		text4: 'or use global or local payment options.',
		text5: 'Payments are accepted online or in stores',
		text6: 'with all cryptocurrencies.',
		text7: 'Make sure your customers',
		text8: 'pay the way they want and',
		text9: 'make payments quickly.',
		text10: 'Learn more about',
		text11: 'accepting payments online.',
		text12: 'Customers can use a variety of payment methods on a site,',
		text13: 'mobile or app as a single solution.',
		text14: 'More information about online checkout',
		text15: 'More information about subscription services.',
		text16:
			'You can encourage customers to pay by sending free custom invoices',
		text17: 'that are easy to pay.',
		text18: 'More information about issuing an invoice',
		text19: 'Receive payment using our ONETETHER payment system',
		text20: 'on various social media platforms.',
		text21: 'Learn more about social sales',
		text22:
			'Our credit and online payment services allow you to accept online and',
		text23: 'in-store payments with most major cryptocurrencies.',
		text24: 'Have the customer pay while shopping themselves.',
		text25: 'here',
		text26: 'Find out how it works',
		text27: 'Manage ONETETHER Settings business, the perfect POS solution,',
		text28:
			'by accepting all types of popular transactions and tracking sales.',
		text29: 'Learn more about ONETETHER Settings',
	},
	'rtr_business-how-pay': {
		title1: 'Business Payment and Funding Access',
		title2: 'Purchase conveniently.',
		title3: 'If you just pay',
		title4: 'Payment',
		title5: 'Getting started today',
		text1: 'Simplify business transactions',
		text2: 'with us when you transfer, spend, and moving.',
		text3:
			'Do you need a highly customizable commercial solution for your business?',
		text4: 'Learn about ONETETHER for business use.',
		text5: 'Use your ONETETHER balance to',
		text6: 'pay for online and direct business fees.',
		text7: 'Save time and trouble sending funds electronically.',
		text8: 'Learn how to transfer',
		text9:
			'You can easily send it to multiple people and places simultaneously.',
		text10: 'Learn more about the sales money.',
		text11: 'Join a seller who relies on ONETETHER.',
		text12: 'Join a business account',
		text13:
			'1. To maintain and use money with ONETETHER, you must have a ONETETHER business account or a ONETETHER balance account.',
		text14:
			"2. Transactions that allow you to receive bonus cashback when you purchase 'ONETETHER Business Debit BlockChain' are as follows. Credit transactions signed by you and processed by blockchain cards, cash withdrawals, transactions processed as cash services or using PINS for transactions with no cashback offers",
		text15:
			"'ONETETHER Business Debit BlockChain' is issued by ONETETHER.The card can be used wherever ONETETHER is allowed. This is just the card issuer and is not responsible for any related accounts or other products, services or suggestions.",
	},
	'rtr_business-how-risk': {
		title1: 'For the mind of the',
		title2: 'customer and the consumer',
		title3: 'Rich Experience',
		title4: 'Transaction safely',
		title5: 'Fraud detection technology',
		text1: 'We can to protect our business using machine learning and',
		text2: "protect both our customers' assets and our consumers.",
		text3: 'Does your business need a highly customizable commerce solution?',
		text4: 'Learn about ONETETHER for Business',
		text5:
			'Please use the trannsaction safely through ONETETHER, which was created based on the',
		text6:
			'blockchain know-how that started from the beginning of the blockchain being known.',
		text7: "With the world's most secure blockchain,",
		text8: 'we can reach customers around the world.',
		text9: 'Our fraud detection tools get smarter with each transaction,',
		text10: 'protecting you from existing and evolving threats.',
	},
	'rtr_business-operation-corps': {
		title1: '기업에 관해',
		text1: '보안과 관리는 저희가 합니다.',
		text2: '운영에만 신경 쓰시면 됩니다.',
		title2: '가맹점 관리도 자동으로',
		text3: '아직도 일일이 관리를 하고 계신가요?',
		text4: 'ONETETHER만 사용하면 자동으로',
		title3: '회원가입하고 가맹점 등록 끝',
		text5: '가맹점 관리 프로그램 무료.',
		text6: '사용료 없이 평생 무료 사용.',
	},
	'rtr_business-operation-platform': {
		title1: '플랫폼 및 기능',
		text1: '기업관리에 최적화.',
		text2: '오로지 기업에 맞추어져 있습니다.',
		title2: '가맹점 관리에서부터',
		title3: '정확한 정산까지',
		text3: '기업에 최적화된 플랫폼을 만나보세요.',
		title4: '직관적이고 심플합니다.',
		text4: '기업에 관해서는 최대한 심플하게',
		title5: '배우지 않아도',
		title6: '바로 사용 가능하게',
		text5: '플랫폼과 기능을 최대한 심플하게.',
		text6: '그래서 관리자가 쉽게 사용 가능합니다.',
	},
	'rtr_business-operation-pay': {
		title1: '지불 방법',
		text1: '고객은 휴대폰 하나로 가맹점에 지불 가능.',
		title2: '가맹점에 지불된',
		title3: 'ONETETHER는',
		text2: '가맹점별로 정산 또는 전체 가맹점 정산',
		title4: '정산된 ONETETHER는 고정되어',
		title5: '언제든지 출금 가능합니다.',
	},
	'rtr_business-operation-global': {
		title1: '글로벌 결제 처리',
		text1: 'ONETETHER를 받아서 원하는 나라에 맞게 출금 가능.',
		title2: '현재 환율에 자동 적용',
		text2: '언제든지 원하는 시간에 출금.',
		title3: 'ONETETHER 고객은 나라에',
		title4: '상관없이 결제 가능합니다.',
		title5: '암호화폐를 사용하는 이유',
		text3: '가장 좋은 이유는 환율의 개수만 보면 되기 때문입니다.',
	},
	'rtr_business-asset-pay': {
		title1: 'ONETETHER 가맹점 등록',
		text1: '고객이 지불한 페이는 등록된 가맹점 별로 정산',
		title2: '가맹점이 많아도',
		title3: '한번에 전체 정산',
		text2: '품목별까지 꼼꼼하게 놓치지 않고 정산됩니다.',
		title4: '언제든지',
		title5: '원하는 방식으로 지불',
		text3: '암호화폐로 지불할 수 있고',
		text4: '원하는 통화쌍으로 지불이 가능합니다.',
	},
	cs: {
		title: 'Customer Center',
		notice: 'Notice',
		inquiry: {
			inquiry: '1:1 Inquiry',
			list: 'Inquiry List',
			type: 'Inquiry Type',
			title: 'Title',
			date: 'Registration Date',
			status: 'Status',
			pending: 'Pending',
			complete: 'Complete',
			no_content: 'There is no inquiry.',
			text1: 'The inquiry you wrote',
			text2: 'has been received successfully',
			text3: 'received.',
		},
		faq: 'Frequently Asked Questions',
		ticket: {
			id: 'Ticket ID',
			text1: 'This is the ID required to check the answer to the inquiry.',
			text2: '문의내역 확인을 위해 PIN 코드를 입력하세요.',
			text3: 'Check inquiry details',
			text4: 'Please enter the ticket and',
			text5: 'password issued to you when inquiring.',
			input1: 'Please enter the Ticket ID',
			input2: 'Please enter your password.',
		},
		placeholder: {
			type: 'Please select inquiry type.',
			title: 'Please enter a title.',
			content: 'Please enter your inquiry.',
		},
	},
	'rtr_auth-login': {
		text1: 'Did you forget your ID/Password?',
	},
	'rtr_auth-find-account': {
		text1: 'Find ID',
		text2: 'Find Password',
		text3:
			'You can find it through the email you entered when you joined ONETETHER.',
		text4:
			'You can find it through the ID and email you entered when you joined ONETETHER.',
		text5: '비밀번호를 변경해 주세요.',
		placeholder1: 'Please enter the e-mail address.',
		placeholder2: 'Please enter ID',
		placeholder3: '인증번호를 입력해주세요.',
		placeholder4: '새 비밀번호를 입력해주세요.',
		placeholder5: '새 비밀번호 확인을 입력해주세요.',
	},
	'rtr_auth-register': {
		text1: 'Join ONETETHER.',
		text2: 'which is used by countless people every day.',
		text3: 'Starting to sign up.',
		text4: 'Please accept the terms of service.',
		text5:
			'All consent includes consent for mandatory and optional items, and you can select individual items to agree to. The service is available even if you refuse to agree to optional items.',
		text6: 'Accept All',
		id: 'Please enter your ID.',
		email: 'Please enter your email address.',
		userName: 'Please enter your user name.',
		password: 'Please enter your password.',
		rePassword: 'Please enter your password again.',
		show: 'Read more',
		agree: 'Accept',
		signUp: 'Sign Up',
		cancel: 'Cancel',
		confirm: 'Confirm',
		success: 'Sign up is complete.',
		duplicated: 'Duplicate ID.',
		required: '(required)',
		modal: {
			title1: 'ONETETHER Service Terms and Conditions',
			text1: 'These Terms and Conditions apply to all users on March 16, 2022.',
			text2: 'Welcome to ONETETHER.',
			text3:
				"The service of Japan's ONETETHER is provided by the national change corporation, ONETETHERPte.Ltd.",
			text4:
				'ONETETHERPte.Ltd. is registered with the Japan Financial Services Agency.',
			text4_1:
				"For more information on ONETETHER's registration with the Financial Services Agency and",
			text5: "please visit Japan's ONETETHER business.",
			text6:
				"This User Terms and Conditions regulates for the use of the Japanese customer's ONETETHER account and ONETETHER service.",
			text7:
				'If the customer is an individual, he must be a Japanese resident and must be 18 years of age or older in order to open a ONETETHER account and use the ONETETHER service.',
			text8:
				'If the customer is a business owner or a private business owner, he must be established and operated in Japan or a resident of Japan in order to open a ONETETHER account and use the ONETETHER service.',
			text9:
				'By opening and using a ONETETHER account, you agree to comply with all of these Terms and Conditions.',
			text10:
				'You also agree to comply with each of the other terms and conditions set forth on the additional pages below,',
			text10_1: 'policies and terms and conditions pages that apply to you.',
			link1: "Japan's ONETETHER services",
		},
	},
	'rtr_auth-dashboard': {
		text1: 'Popular Assets',
		text2: 'Favorite Assets',
		text3: 'You can register up to 5 favorite wallets/accounts.',
		send: 'Send',
		request: 'Request',
		history: 'Transaction details',
		greeting_message: '{user} last visit is at {date}.',
	},
	'rtr_pay-payment': {
		title1: 'Send Assets',
		title2: 'Withdrawal method',
		text1: 'Withdraw to another user',
		text2: 'Withdraw using a blockchain network',
		text3: 'Offline Store Payment (Mobile Only)',
		text4: 'Recipient account number',
		text5: 'Enter the account number.',
		text6: 'Receipt Wallet Address',
		text7: 'Enter the wallet address.',
		text8: 'Sending Quantity',
		text9: 'Offline Store Payments',
		text10: 'Remaining time',
		text11: 'Payment availability timed out.',
		text12: 'Please press the button.',
		text13: 'Reissue code',
		caution: 'Account number does not exist or is an invalid input value.',
		caution2: 'Account number does not exist or is an invalid input value.',
		recipient: 'Recipient Name',
		askWithdraw: 'Would you like to withdraw?',
		scan: 'QR Scan',
		modal: {
			success: 'The payment has been made normally.',
			recipient: 'Recipient Name',
			wallet_account: 'Wallet Address',
			payment_amount: 'Payment amount',
			check_info: 'Please check the withdrawal information.',
			account_number: 'Account number',
		},
	},
	'rtr_pay-deposit': {
		title1: 'Receive Deposit',
		title2: 'Deposit method',
		text1: 'Deposit to another user',
		text2: 'Deposit using blockchain network',
		text3: 'Invoice',
		text4: 'Account number to receive the deposit',
		text5: 'Wallet address to receive deposit',
		text6: 'There is no wallet address created.',
		text7: 'Please check the request information.',
		text8: 'Please enter an email.',
		text9: 'Please enter an item.',
		text10: 'Please enter the billing amount.',
		my_wallet: 'My Wallet Address',
		my_account: 'My account Number',
	},
	'rtr_pay-exchange': {
		title1: 'Exchange',
		tab1: 'Buy',
		tab2: 'Sell',
		text1: 'Please select a crypto asset.',
		text2: 'Purchase quantity',
		text3: 'Applicable quantity',
		text4: 'Buy Fees',
		text5: 'Sell Fees',
		text6: 'Sales base rate',
		text7: 'Applied exchange rate',
		text8: 'Sales quantity',
		text9: ' Proceed?',
		text10: 'Select cryptographic asset to buy.',
		text11: 'Select cryptographic asset to pay.',
		text12: 'Select cryptographic asset to sell.',
		text13: 'Select cryptographic asset to accept payment.',
	},
	c2c: {
		buy_list: 'Buy List',
		th1: 'Sales Assets',
		th2: 'Available Quantity',
		th3: 'Price',
		th4: 'Payment Assets',
		th5: 'Status',
		status1: 'All',
		status4: 'Cancel',
		OPEN: 'Open',
		CANCELED: 'Cancel',
		COMPLETED: 'Completed',
		PENDING: 'Pending',
		PAYED: 'Holding',
		REJECTED: 'Rejected',
		CONFIRMED: 'Confirmed',
		escrow_type: {
			BOTH: 'Deposited by both Discloser and Requester',
			DEALER: 'Preferred Deposit of Disclosure of Sale',
			APPLICANT: 'Purchase Requester Preferred Deposit',
			DISABLE: 'Disable',
		},
		check: {
			title: 'New Account Registration',
			text1: 'Please add the wallet/account.',
			text2: '생성된 계좌가 없습니다.',
			text3:
				'P2P 서비스는 2개 이상의 지갑/계좌를 보유하신 고객만 이용할 수 있습니다',
		},
		search: {
			title: 'Search Cryptographic Asset',
			head1: 'All',
			head2: 'Recent',
			head3: 'Result',
			delete: 'Delete All',
			empty: 'No results',
		},
		buy: {
			title: 'Purchase Registration',
			title1: 'Precautions for purchase registration',
			head1: '허위 홀딩 금지',
			head2: 'P2P Trading',
			text1:
				'구매자는 반드시 해당 P2P 거래에 대한 지불이 완료된 후에 ‘홀딩’을 클릭하셔야 합니다.',
			text2:
				'허위 홀딩으로 인해 발생하는 판매자와 구매자간의 분쟁은 ONETETHER 에서 책임지지 않습니다. ',
			text3:
				'또한 허위 홀딩을 지속적으로 행할 시 서비스 이용에 제한이 가해짐을 유의하시기 바랍니다.',
			text4:
				'지불을 완료한 후에 확정이 되지 않을 경우에는 1대1 문의를 통하여 관리자에게 문의해주시기 바랍니다.',
			text5:
				'외부지갑을 통해 P2P 거래를 할 경우에는 수수료가 부과될 수 있으며 P2P 거래가 정상적으로 이루어지지 않을 경우에는 해당 거래 해결에 대해 불편함이 있을 수 있습니다.',
			text6:
				'P2P 거래는 판매자와 구매자의 자유로운 거래 활동을 기반으로 합니다.',
			text7:
				'ONETETHER 는 판매자와 구매자의 편리하고 안전한 거래를 위한 플랫폼 서비스만을 제공합니다.',
			text8:
				'판매자와 구매자간의 법적 분쟁이 발생했을 시 ONETETHER 는 에스크로의 역할로서만 책임을 지는 점 유의하시기 바랍니다.',
			head3: 'Assets to be purchased',
			head4: '총 판매 수량',
			head5: '개당 판매 가격',
			head6: '가용 수량',
			head7: '보유',
			head8: '구매 수량',
			head9: 'Fee',
			head10: '지불할',
			head11: '수량',
			head12: '지불 계좌',
			text9: 'The fee is',
			text10: ' deducted.',
		},
		sell: {
			title: 'Sales Registration',
			title1: 'Precautions for sales registration',
			head1: '허위 공시 금지',
			head2: '확정 버튼 클릭 시 주의사항',
			head3: '확정 버튼을 누르지 않았을 시',
			head4: 'P2P Trading',
			text1:
				'판매자는 반드시 판매에 필요한 암호자산을 충분히 보유한 후 거래를 하시기 바랍니다.',
			text2:
				'허위공시를 지속적으로 행할시 서비스 이용에 제한이 가해짐을 유의하시기 바랍니다.',
			text3:
				'판매자는 구매자의 지불을 반드시 확인한 후에 ‘확정’ 버튼을 클릭하셔야 합니다.',
			text4:
				'판매자의 부주의로 인해 발생하는 금전적 손해에 대해서 ONETETHER 는 법적으로 책임이 없습니다.',
			text5: '반드시 구매자의 지불여부를 확인해주십시오.',
			text6:
				'판매자는 구매자의 지불여부를 확인한 후 반드시 ‘확정’버튼을 클릭하셔야 합니다.',
			text7:
				'‘확정’버튼을 클릭하지 않았을 시 관리자에 의해 서비스 이용에 제한이 가해짐을 유의해 주시기 바랍니다.',

			text8:
				'P2P 거래는 판매자와 구매자의 자유로운 거래 활동을 기반으로 합니다.',
			text9:
				'ONETETHER 는 판매자와 구매자의 편리하고 안전한 거래를 위한 플랫폼 서비스만을 제공합니다.',
			text10:
				'판매자와 구매자간의 법적 분쟁이 발생했을 시 ONETETHER 는 에스크로의 역할로서만 책임을 지는 점 유의하시기 바랍니다.',
			text11: 'Fee',
			placeholder1: 'Please select a cryptographic asset to sell.',
			placeholder2: 'Please select the cryptographic asset to be paid for.',
			head5: '판매 수량',
			head6: 'Min quantity for order',
			head7: 'Spread Ratio',
			head8: '개당 판매 가격',
		},
	},
	'rtr_pay-contact': {
		search: 'Search',
		bookmark: 'Bookmark',
		name: 'Name',
		account: 'Account Number',
		memo: 'Memo',
		location: 'Location',
		status: 'Profile Condition',
		text1: 'Everyone has your account number',
		text2: 'jpys a search and you can deposit.',
	},
	'rtr_pay-invoice': {
		title1: 'Billing To',
		input1: 'Email',
		title2: 'Item',
		input2: 'Product Name',
		title3: 'Cryptographic assets to be received',
		title4: 'the due date of payment',
		title5: 'Total',
		text1: 'Do you want to request?',
	},
	'rtr_mypage-account': {
		title: 'Account',
		name: 'Name',
		email: 'E-mail',
		password: 'Password',
		new_password1: 'New password',
		new_password2: 'Confirm new password',
	},
	'rtr_mypage-data': {
		title1: 'Security',
		text1: 'Install "Google Authenticator" app on your smartphone or desktop.',
		text2:
			'Android or other systems, including iPhone, iPad, and iPod, Windows Phone, and Microsoft',
		text3: 'Windows Desktop.',
		text4: 'Please write this key ',
		text5:
			'on paper. It is used when you lose your device or need to change your OTP.',
		text6:
			'Launch the "Google Authenticator" app and tap the Scan QR barcode at the bottom of the screen.',
		text7:
			'Enter the authentication code displayed on the screen of the device in the "Authentication Code" space below.',
		text8: 'OTP key',
		text10: 'OTP key',
		text11: ' (Enter the authentication number below to activate OTP)',
		text12: 'Please enter authentication number.',
		text13: 'To disable OTP, enter the authentication number below.',
	},
	'rtr_wallet_account-assets': {
		title1: 'Asset list',
		title2: 'Wallet/Account',
		title3: 'Account registration',
		tab1: 'Assets',
		tab2: 'Bookmarks',
		empty: 'There is no selected asset.',
		text1: 'You can register up to 5 favorite wallets/accounts.',
		text2: 'Please add the wallet/account.',
		account: 'Account',
		address: 'Address',
	},
	'account-wallet': {
		title1: '나의 지갑',
		title2: '나의 계좌',
		btn_charge: 'Charging',
		btn_jpys_send: 'Make a transfer',
		btn_other_send: '출금하기',
		btn_receive: 'Deposit',
		text1: 'Payment and ONETETHER can be used without JPYS.',
		my_wallet: 'My wallet address',
		my_account: 'My account number',
		btn_copy: 'Copy',
		modal: {
			title1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
			text1:
				'암호자산이 비대면으로 개설되면서 자동화기기, 인터넷을 통한 인출(이체)한도가 있습니다.',
			text2:
				'거래목적을 확인 할 수 있는 객관적 인증자료를 제시하시기 바랍니다.',
			text3: "'설정'에서 한도제한을 해제 할 수 있습니다.",
			title2: '유의사항',
			text4:
				'인터넷뱅킹 가입은 입출금 계좌를 개설 하신 후 완료화면에서 연동하여 신청 할 수 있습니다.',
			caution:
				'인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상 시킨 후 출금한도 및 이체한도를 올리시기 바랍니다.',
			text5:
				'신규가입 버튼을 클릭하면 회원님 고유의 (암호자산) ONETETHER 전용계좌 및 외부 지갑 연동 입금주소가 발급됩니다.',
			text6:
				'입금 전 꼭 알아두세요! ONETETHER 계좌에서 계좌로 송금하면 최저가 수수료 또는 무료 일 수 있습니다.',
			text7:
				'신규가입시 발행되는 계좌/지갑 주소로는 (암호자산) 입금만 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도 할경우에 발생 할 수 있는 오류/손실은 복구 불가능합니다.',
			text8:
				'1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다.',
			text9:
				'입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
			text10:
				'회원님에게 할당 된 신규가입으로는 (암호자산) 을 입금할 수 있습니다.',
			check1: '위 사항을 동의 및 숙지 하셨습니까?',
		},
	},
	rtr_activity: {
		title: 'Activity Detail',
		start: 'Start',
		end: 'Close',
		search: 'Active Search',
		button1: 'Statement',
		select: 'Please select',
		text1: "There's no transaction yet.",
		text2: 'Try again after chose the start and close date.',
		withdrawal: 'Withdrawal',
		deposit: 'Deposit',
		type: 'Type',
		registration_date: 'Registration Date',
		asset_name: 'Asset Name',
		sender: 'Sender',
		recipient: 'Recipient',
		amount: 'Transfer Amount',
		w_account: 'Withdrawal Account',
		d_account: 'Deposit Account',
		w_address: 'withdrawal wallet address',
		d_address: 'Deposit wallet address',
		detail: 'Transaction Details',
		text3: 'Sent Quantity',
		text4: 'Deposit account number',
		text5: 'Assets received',
		text6: 'Quantity received',
		text7: 'withdrawal account number',
		text8: 'Sent Assets',
		account: 'Account',
		wallet: 'Wallet',
		check_all: 'Check All',
		account_number: 'Account Number',
		empty: 'There is no registered transaction history.',
	},
	'rtr_activity-exchange': {
		title1: 'Exchange Detail',
		tab1: 'All',
		tab2: 'Buy',
		tab3: 'Sell',
		th1: 'Type',
		th2: 'Registration date',
		th3: 'Base asset quantity',
		th4: 'Relative asset quantity',
		th5: 'Applied sales base rate',
		th6: 'Applied spread rate',
		th7: 'Applied exchange rate',
		buy: 'buy',
		sell: 'sell',
		empty: 'There is no registered currency exchange history.',
		detail: {
			title1: 'Currency exchange details',
			th1: 'Base Assets',
			th2: 'Relative Assets',
			th3: 'Base asset quantity',
			th5: 'Base asset account number',
			th6: 'Relative asset account number',
			th10: 'Type',
			th11: 'Application date',
			th12: 'Sales asset',
			th13: 'Sales asset amount',
			th14: 'Sales asset account',
		},
	},
	'rtr_activity-c2c': {
		title1: 'P2P Detail',
		title2: 'Purchase details',
		title3: 'Sales Status',
		title4: 'Sales Status Details',
		tab1: 'Purchase history',
		tab2: 'Sales history',
		purchased_asset: 'Purchased asset',
		purchase_quantity: 'Purchase quantity',
		purchase_price: 'Purchase price',
		payment_asset: 'Payment asset',
		total_fee: 'Total fee',
		account_number: 'Account number',
		status: 'Status',
		application_date: 'Application date',
		registration_date: 'Registration date',
		closing_date: 'Closing date',
		amount_paid: 'Amount paid',
		deposit_amount: 'Deposit amount',
		sold_asset: 'Sold asset',
		sold_quantity: 'Sold quantity',
		registered_quantity: 'Registered quantity',
		sold_price: 'Sold price',
		safety_type: 'Purchase Safety Type',
		min_purchase_quantity: 'Min purchase quantity',
		available_quantity: 'Available quantity',
		confirmed_sales_quantity: 'Confirmed sales quantity',
		unconfirmed_sales_quantity: 'Unconfirmed sales quantity',
		charge_fee: 'Sell distributor charges fees',
		empty: 'There is no registered purchase history.',
		empty2: 'There is no registered sales history.',
	},
	'rtr_activity-invoice': {
		title: 'Invoice Detail',
		target: 'Billing target',
		request_asset: 'Requested assets',
		request_amount: 'Requested amount',
		item: 'Item',
		due_date: 'Due date',
		empty: 'There is no registered invoice history.',
	},
	auth: {
		id: 'Please enter ID.',
		password: 'Please enter password.',
		login_btn: 'Login',
		signup_btn: 'Sign Up',
		or: 'or',
	},
	banner1: {
		text1: "Don't have a wallet/account?",
		text2: 'Create your ONETETHER',
		text3: 'wallet/account for free now, ',
		text4: 'the safest and fastest way to make it.',
		text5: 'Make it free now!',
	},
	banner2: {
		text1: 'Service operating hours',
		text2: '(Available 24 hours)',
		text3: 'Online Bank Hours of Operation',
		text4: 'Open all year 24hours',
		text5: '(Not available 23:00 - 24:00)',
		text6: 'Offline Bank Hours of Operation',
		text7: '(Closed on weekends and holidays)',
	},
	account_register: {
		title1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
		text1:
			'요구불계좌가 비대면으로 개설되면서 자동화기기, 인터넷을 통한 인출(이체) 한도는 1일 일정 금액 제한됩니다.',
		text2:
			'거래목적을 확인 할 수 있는 객관적 인증자료를 지점에 제시 및 “관리 > 보안 인증/관리”에서 한도제한을 해제할 수 있습니다.',
		text3: '인터넷뱅킹 이용 시 출금계좌로 등록해야 이체거래를 할 수 있습니다.',
		text4: '암호자산별 한도제한 계좌는 1인당 5개만 개설할 수 있습니다.',
		title2: '유의사항',
		text5:
			'- 인터넷뱅킹 가입은 입출금계좌를 개설 하신 후 완료화면에서 연동하여 신청 할 수 있습니다.',
		text6:
			'- 기존 인터넷뱅킹 가입 고객은 출금계좌 등록구분이 인터넷+지점으로 되어 있을 때만 인터넷 뱅킹으로 출금계좌 등록을 할 수 있음을 유의해주세요.',
		text7:
			'* 인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여등급을 향상 시킨 후 출금한도및 이체한도를 올리시기 바랍니다.',
		title3:
			'신규가입 버튼을 클릭하면 회원님 고유의 { title } ONETETHER 전용계좌 및 외부 지갑 연동 입금주소가 발급됩니다.',
		text8:
			'입금 전 꼭 알아두세요! ONETETHER 계좌에서 계좌로 송금하면 최저가 수수료 또는 무료 일 수 있습니다.',
		text9:
			'신규가입시 발행되는 계좌/지갑 주소로는 { title } 입금만 가능합니다.',
		text10:
			'해당 주소로 다른 디지털 자산을 입금 시도 할 경우에 발생 할 수 있는 오류/ 손실은 복구 불가능합니다.',
		text11: '1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다.',
		text12:
			'입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요시간이 달라질 수 있습니다. 위 주소는 입금전용 주소입니다.',
		text13:
			'회원님에게 할당 된 신규가입으로는 { title } 을 입금할 수 있습니다.',
		agree: '위 사항을 동의 및 숙지 하셨습니까?',
		title4: '계좌 고유 번호',
		title5: '계좌 번호',
		title6: '계좌 이름',
		text14: '계좌 이름을 입력 하세요.',
		title7: '정지금액',
		title8: 'Condition',
		title9: '선택 자산',
		text15: '자동으로 입력 됩니다.',
		title10: '생성 된 계좌번호',
		text16: 'ONETETHER 전용 계좌번호',
	},
	merchant: {
		picker: {
			title1: 'Select store to manage.',
			title2: 'Store Registration',
			success_shop_register: 'The Merchant has been registered.',
			insert_shop_name: 'Please enter the Merchant name.',
			insert_shop_id: 'Please enter the Merchant ID.',
			merchant_name: 'Merchant Name',
			merchant_id: 'Merchant ID',
			regist_date: 'Registration Date',
		},
		transaction: {
			text1: 'Payment History',
			text2: "There's no transaction yet.",
			text3: 'Try again after chose the start and close date.',
			text4: 'Payment detail',
			empty: 'There are no registered payment details.',
			total_count: 'Total',
			total_amount: 'ToTal Amount',
			count: ' thing',
			table: {
				time: 'Payment Date',
				name: 'Payment Items',
				id: 'Payment ID',
				payer: 'Payer Name',
				type: 'Payment Type',
				status: 'Condition',
				amount: 'Payment Amount',
				order_no: 'Store Order Number',
			},
		},
		settlement: {
			title: 'List of settlement accounts',
			title1: 'Settlement Account Connect',
			title2: 'Settlement Account disconnect',
			date: 'Registration Date',
			asset_name: 'Assets Name',
			account: 'Account Number',
			no_content: 'No articles registered',
			select: 'Please select a cryptographic asset.',
			name: 'Merchant Name',
			id: 'Merchant ID',
			asset: 'Settlement Account',
			connect: 'Settlement Account Connect',
			disconnect: 'Disconnect',
			set_disconnect: 'Disconnect Settlement Account',
			disconnect2: 'Settlement account connection has been terminated.',
		},
		title1: 'Transaction Statistics',
		title2: 'A Settlement Calendar',
		title3: 'Quick menu',
		title4: 'Notice',
		title5: 'Customer Service',
		title6: 'Managing Authentication',
		menu1: 'Store Information',
		menu2: 'List of settlement accounts',
		menu3: 'Individual inquiry',
		menu4: 'Inquiries',
		menu5: 'Email Authentication',
		menu6: 'OTP Authentication',
		menu7: 'Security level',
		menu_2: {
			menu1: 'Notice',
			menu2: 'Individual inquiry',
			menu3: 'Inquiries',
			menu4: 'Frequently Asked Questions',
			menu5: 'KYC Authentication',
			menu6: 'Email Authentication',
			menu7: 'OTP Authentication',
			menu8: 'Withdrawal Address Authentication',
			menu9: 'Security level',
		},
		inquiry: {
			text1: 'Please select inquiry type.',
			text2: 'Please enter the title.',
			text3: 'Please write your inquiry.',
			text4: 'Inquiry Type',
			text5: 'Title',
			text6: 'Registration date',
			text7: 'Condition',
			text8: 'Waiting for response',
			text9: 'Response complete',
			text10: 'There is no registered content.',
			text11: '문의 작성하신 내용이',
			text12: '정상적으로 접수 완료',
			text13: '되었습니다.',
		},
		kyc: {
			text1: '회원 고유 번호',
			text2: '사용자 이름',
			text3: '이메일',
		},
		email: {
			link1: 'Resend Authentication Code',
		},
		otp: {
			text1:
				'Install "Google Authenticator" app on your smartphone or desktop.',
			text2:
				'Android or other systems, including iPhone, iPad, and iPod, Windows Phone, and Microsoft Windows Desktop.',
			text3: 'Please write this key,',
			text4:
				'on paper. It is used when you lose your device or need to change your OTP.',
			text5:
				'Launch the "Google Authenticator" app and tap the Scan QR barcode at the bottom of the screen.',
			text6:
				'Enter the authentication code displayed on the screen of the device in the "Authentication Code" space below.',
			text7: 'OTP key',
			text8: 'OTP key (Enter the authentication number below to activate OTP)',
			text9: 'Enter verification number.',
		},
		address: {
			select: '선택없음',
			text1: 'Select assets',
			text2: 'Assets Address',
			text3: 'Please write the assets address',
			text4: '이미 인증이 완료된 자산입니다.',
			text5: '뱅크 선택',
			text6: '예금주 명',
			text7: 'Account Number',
			text8: '생일',
			text9: '생년월일 6자리',
			register: 'Registeration',
			alert: '출금주소 인증이 완료되었습니다.',
		},
		security: {
			authStatus: {
				ok: 'Authentication complete',
				no: '인증하기',
			},
			level1: 'Level 1',
			level2: 'Level 2',
			level3: 'Level 3',
			level4: 'Level 4',
			email: 'Email Authentication',
			kyc: 'KYC Authentication',
			otp: 'OTP Authentication',
			address: 'Withdrawal Address Authentication',
			title1: '회원고유번호',
			title2: '유저명',
			title3: 'Restrictions',
			text1: 'Limit on asset amount per withdrawal 100 ETH',
			text2: '100 ETH',
			text3: 'Limit on asset amount per day 1,000 ETH',
			text4: '1,000 ETH',
			text5: 'Limit on asset amount per withdrawal 10 BTC',
			text6: '10 BTC',
			text7: 'Limit on asset amount per day 1,000 BTC',
			text8: '1,000 BTC',
			placeholder: 'Please write the e-mail address.',
			placeholder1: '인증코드를 5분 이내에 입력해 주세요.',
		},
		info1: ' is',
		info2: 'Level ',
		info3: 'The security level of.',
	},
	input: {
		placeholder: {
			search: 'search',
			select_assets: 'Please select a asset.',
			search_assets: 'Please search a asset.',
			search_activity: 'Active Search',
			email: 'please enter your e-mail address.',
			code_request: 'Please enter the verification code.',
			inquiry_type: 'Please select inquiry type.',
			enter_subject: 'Please enter the title.',
			inquiry_content: 'Please write your inquiry.',
			password: 'Please enter your password.',
			all_assets: 'All assets',
		},
		label: {
			email: 'E-mail',
			password: 'Password',
			inquiry_type: 'Inquiry Type',
			enter_subject: 'Title',
			inquiry_content: 'Inquiry',
		},
	},
	select: {
		select: 'Please Select.',
		all: 'All',
	},
	button: {
		add: 'Add',
		delete: 'Delete',
		cancel: 'Cancel',
		change: 'Change',
		pay: 'Make a Payment',
		next: 'Next',
		back: 'Back',
		request: 'Request',
		send: 'Send',
		close: 'Close',
		do_not_look: '다시보지않기',
		confirm: 'Confirm',
		signup: 'Sign Up',
		down: 'Download App',
		edit: 'Edit',
		edit1: 'Editing',
		delete_account: '계정 탈퇴',
		code: 'Send Verification Code',
		code_check: 'Confirm the Authentication Code',
		code_completed: '인증 완료',
		otp: 'Activate OTP',
		otp_disabled: 'OTP Deactivate',
		asset_send: 'Send Asset',
		cryptocurrency_request: 'Cryptocurrency Request',
		membership_withdrawal: 'Membership Withdrawal',
		info: 'Contact Sales Department',
		share: 'Share',
		new_account: 'Open Account',
		open_account: 'Open',
		search: 'Search',
		start: 'Getting Started',
		register: 'Registration',
		list: 'List',
		inquiry_list: 'To Inquiry',
		exchange: 'Exchange Money',
		check_balance: 'Check Balance',
		sales: 'Sales Registration',
		purchase: 'Purchase Registration',
		withdraw: 'Withdraw',
		copy: 'Copy',
		detail: 'Detail',
		payment: 'Payment',
		decide: 'Decide',
		check: 'Check',
		reject: 'Reject',
		application: 'Application',
		connect: 'Connect',
		not_see_today: 'Do not show today',
		receive_request: 'Request to receive',
		block: 'Block',
		more: 'More',
	},
	modal: {
		message: {
			select_asset: 'Please select the assets.',
			select_way: 'Please select a withdrawal method.',
			check_account: "Please check the recipient's account.",
			check_address: "Please check the recipient's address.",
			set_amount: 'Please enter the transfer amount.',
			need_agree: 'You can sign up for a new one only if you agree.',
			success_exchange:
				'The currency exchange has been processed successfully.',
			no_account: 'No account has been opened.',
			set_otp: 'OTP activation is complete.',
			deactivation_otp: 'OTP deactivation is complete.',
			set_code: 'Please enter a certification number.',
			set_buy: 'Would you like to purchase it?',
			registered: 'Has been registered.',
			set_sell: 'Would you like to sell it?',
			success_withdraw: 'The withdrawal has been completed.',
			success_confirm: 'The confirmation was successfully processed.',
			success_cancel: 'The Cancellation was successfully processed.',
			success_payment: 'The payment was successfully processed.',
			success_reject: 'The reject was successfully processed.',
			set_cancel: 'Would you like to cancel?',
			set_pay: 'Would you like to pay?',
			set_confirm: 'Would you like to confirm?',
			set_reject: 'Would you like to reject?',
			sent_id: 'The ID has been sent to your email.',
			sent_authCode: 'The Auth code has been sent to your email.',
			pw_changed: 'Password has been changed.',
			settlement_connect: 'The settlement account has been connected.',
			settlement_disconnect:
				'Are you sure you want to close your settlement account?',
			settlement_disconnect2: 'The settlement account has been disconnected.',
			merchant_regist_confirm: 'The merchant registration has been completed.',
			complete_payment: 'The payment has been completed.',
		},
		account: {
			status1: '변경 할 항목을 입력해주세요.',
			status2: '계정정보가 변경되었습니다.',
			status3: '회원탈퇴가 완료되었습니다.',
			status4: '계정을 삭제하시겠습니까?',
			status5: '회원 이름을 입력해주세요.',
			status6: '비밀번호를 입력해주세요.',
			status7: '새 비밀번호를 입력해주세요.',
			status8: '새 비밀번호 확인을 입력해주세요.',
			status9: '새 비밀번호와 비밀변호 확인이 일치하지 않습니다.',
		},
		history: 'Transfer details',
	},
	alert: {
		request_id: 'Please enter ID.',
		request_pw: 'Please enter password.',
		request_check_term: 'Please accept the required terms and conditions.',
		transaction_check: 'Please check the transaction details.',
		not_yet: 'Coming soon.',
		copy_s: 'It has been copied.',
		copy_f: 'Copy failed.',
		logout: 'Do you want to log out?',
		enter_email: 'Please enter email address.',
		enter_authCode: 'Please enter auth code.',
		enter_newPw: 'Please enter new password.',
		enter_newPwConfirm: 'Please enter new password confirm.',
		wrong_newInfo: 'New password and password verification do not match.',
	},
	help: {
		title: 'Help',
		title1: 'General Questions',
		q1: 'Activity not displayed',
		a1: "If you don't see your search history, websites you visit, or other activities in My Activities, please check the following:",
		q2: 'Unknown activity exists',
		a2: 'My Activity might display an unknown type of activity:',
		q3: 'Review recommendation settings for privacy',
		a3: 'You can set the Auto Delete option to manage the activity retention period.',
		q4: 'To verify your privacy settings',
		a4: 'Privacy diagnostics make it easy to view and change most of the settings described below.',
		q5: 'To control which activities to save',
		a5: 'In Activity Control Settings, you can select the type of activity that is stored in your account. The following activities are included:',
		q6: 'To track and delete information',
		a6: 'The following resources help you review and control the activities stored on your Google Account.',
		q7: 'To view a data overview',
		a7: 'Visit the Google Dashboard for a summary of data from several Google services, including Gmail, Drive, and Calendar.',
		q8: 'To view and delete activities/files',
		a8: 'You can view and delete files such as photos, emails, and documents from the following relevant Google products:',
		q9: 'My activities',
		a9: 'Under My Activities, check and delete activities such as search history and websites you visit.',
		q10: 'To view and delete places you have visited',
		a10: "When you enable Location History, the places you visit are saved in your account. I'm the only one who can see my location record.",
		q11: 'Additional Information',
		a11: 'Learn more about my data and how Google uses my data in the following resources:',
		q12: 'To change the activity that is',
		a12: 'You can change this setting to control most of the activities stored in your account.',
		q13: 'To view or delete an activity',
		a13: 'Go to your Google Account.',
		q14: 'If the activity is saved',
		a14: 'Your activity will be saved when you log in to your Google account on your mobile phone. Google can save information based on this setting if Activity Control is enabled.',
		q15: 'To delete an activity',
		a15: 'If you delete an activity manually or automatically delete it according to the Auto Delete setting, the deletion procedure will begin immediately on the product and Google System.',
		q16: 'What is my activity?',
		a16: 'My activities are places where I can check and manage activities such as searches, websites I visited, and videos I watched.',
		q17: 'Find and view activities',
		a17: 'My activities are listed as individual items, starting with the most recent activities.',
		q18: 'Deleting an Activity',
		a18: 'Learn how to delete historical search history, visit history, and other activities from My Activities. You can also set the previous activity to be automatically deleted.',
		q19: 'Accessing data from administrators or service providers',
		a19: 'Owner of data or content submitted or uploaded through an account',
		q20: 'Resolving SafeSearch Issues',
		a20: "If Safe Search doesn't work, find out how to solve the Safe Search problem.",
		q21: 'Reporting sensational content',
		a21: 'If you find sensational content while using SafeSearch, please report it.',
	},
	popup: {
		title1: 'Close beta test ',
		title2: 'JANO supporters',
		title3: ' Recruiting!',
		period: 'Close Beta Period 2022/11/23 ~ 12/23',
		text1: 'We invite JANO supporters to the close beta test of ONETETHER.',
		text2:
			'The PAY platform based on blockchain, the first service of ONETETHER',
		text3: 'Please check out ONETETHER in advance.',
		m_text1: 'Welcome to the ONETETHER',
		m_text2: 'Close Beta Test.',
		m_text3: 'Close beta period',
		m_text4: '2022/11/23',
		m_text5: '~12/23',
	},
	tutorial: {
		dashboard: {
			step1_title: '인기자산',
			step1_text: 'ONETETHER에서 추천하는 인기 자산입니다.',
			step2_title: '보내기',
			step2_text: '버튼을 탭(터치)해서 자산을 보내세요.',
			step3_title: '요청하기',
			step3_text: '버튼을 탭(터치)해서 자산을 요청하세요.',
			step4_title: '거래내역',
			step4_text: '자산을 보내고 받은 내역을 확인하세요.',
			step5_title: '즐겨찾는 지갑/계좌',
			step5_text:
				'다음 아이콘과 동일한 버튼을 탭(터치)하면 즐겨찾는 자산을 설정할 수 있어요.',
			step6_title: '지갑/계좌 만들기',
			step6_text: '다양한 자산을 추가해서 더 많은 서비스를 경험하세요.',
		},
		payment: {
			step1_title: '보내는 자산',
			step1_text: '보낼 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '보내는 방식',
			step2_text: '세가지 방식으로 자산을 보낼 수 있습니다.',
			step3_title: '1. 오프라인 상점 결제',
			step3_text: 'ONETETHER 가맹점에서 QR코드로 간편하게 결제하세요.',
			step4_title: '2. 계좌 번호로 출금',
			step4_text: 'ONETETHER 사용자에게 계좌 번호로 자산을 보내세요.',
			step5_title: '3. 지갑 주소로 출금',
			step5_text: '지갑 주소로 JPYS와 암호자산을 보내세요.',
		},
		deposit: {
			step1_title: '요청하는 자산',
			step1_text: '요청할 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '요청하는 방식',
			step2_text: '세가지 방식으로 자산을 요청할 수 있습니다.',
			step3_title: '1. 계좌 번호로 입금',
			step3_text: 'ONETETHER 사용자에게 계좌 번호로 자산을 요청하세요.',
			step4_title: '2. 지갑 주소로 입금',
			step4_text: '지갑 주소로 자산을 요청하세요.',
			step5_title: '3. 인보이스',
			step5_text: '청구서를 보내 자산을 요청하세요.',
		},
		exchange: {
			step1_title: '구매/판매',
			step1_text: 'ONETETHER에서 제안하는 환전 방식으로 자산을 교환하세요.',
		},
		c2c: {
			step1_title: '판매등록',
			step1_text: '다른 ONETETHER 사용자에게 내가 가진 자산을 판매하세요.',
			step2_title: '목록 갱신',
			step2_text:
				'아이콘 버튼을 탭(터치)해서 현재 판매중인 모든 목록을 확인하세요.',
			step3_title: '구매 신청',
			step3_text: '원하는 판매건을 선택해서 구매를 신청하세요.',
		},
	},
	underConstruction: 'coming soon',
	menu: {
		dashboard: 'Dashboard',
		company: '기업',
		personal: 'Individual',
		'personal-how': 'How to Shop and Buy',
		'personal-how-online_shopping': 'Online Shopping',
		'personal-how-offline_kiosk': 'Offline Kiosk',
		'personal-how-qr': 'Pay with QR Code',
		'personal-how-janopay_creditcard': 'ONETETHER credit card',
		'personal-how-trade_and_cashback': 'Transaction and Cashback',
		'personal-request': 'Send and Receive',
		'personal-request-send': 'Send Asset',
		'personal-request-receive': 'Asset Request',
		'personal-request-deposit': 'Get a deposit',
		'personal-request-commission': 'Fee',
		'personal-asset': 'Asset Management',
		'personal-asset-wallet': 'Wallet',
		'personal-asset-account': 'Account',
		'personal-asset-jpys': 'Add JPYS',
		'personal-asset-sale': 'Sell',
		'personal-asset-exchange': 'Exchanging Currency',
		business: 'Business',
		'business-how': 'Starting method',
		'business-how-start': 'Getting Started',
		'business-how-solution': 'Solution',
		'business-how-receive': 'Accepting Payment',
		'business-how-pay': 'Make a Payment',
		'business-how-risk': 'Risk Management',
		'business-operation': 'Management Method',
		'business-operation-corps': 'About Company',
		'business-operation-platform': 'Platforms and Features',
		'business-operation-pay': 'Payment Method',
		'business-operation-global': 'Global Payment Processing',
		'business-asset': 'Asset Management',
		'business-asset-pay': 'Payment Method',
		'merchant-console-catalog': 'Store Information',
		'merchant-console-transaction-list': 'Payment History',
		'merchant-console-settlement_account': 'List of settlement accounts',
		'merchant-console-cs-notice': 'Customer Service',
		'merchant-console-certification-kyc': 'Managing Authentication',
		development: 'Development',
		cs: 'Customer Service',
		notice: 'Notice',
		inquiry: 'Individual inquiry',
		inquiry_detail: 'Inquiries',
		faq: 'Frequently Asked Questions',
		pay: 'Asset Management',
		'pay-payment': 'Send Asset',
		'pay-deposit': 'Receive Deposit',
		'pay-exchange': 'Exchange',
		'pay-c2c': 'P2P',
		'pay-contacts': 'Contact Information',
		'pay-invoice': 'Invoice',
		wallet_account: 'Wallet/Account',
		'wallet_account-wallet': '지갑열기',
		'wallet_account-account': '계좌열기',
		'wallet_account-assets': '전체자산',
		activity: 'Activity Details',
		'activity-transaction': 'Transaction Details',
		'activity-exchange': 'Exchange Detail',
		'activity-c2c': 'P2P Detail',
		'activity-invoice': 'Invoice Detail',
		help: 'Help',
		setting: 'Setting',
		'setting-security': 'Security',
		'setting-payment': 'Make a payment',
		'setting-notice': 'Notice',
		mypage: 'Mypage',
		merchant: {
			merchant: 'Merchant',
			personal: 'Individual',
			information: 'Information',
			payment_history: 'Payment history',
		},
		'mypage-account': 'Account',
		'mypage-data': 'Data',
		'mypage-certification': 'Certification',
		'mypage-seller_tool': 'Seller Tools',
		logout: 'Logout',
		login_text1: 'Log in',
		login_text2: 'for more information.',
	},
	// rtr_activity,
	merchant_management: {
		menu: 'Menu',
		title: {
			qr_payment: 'Qr Scan',
			payment_list: 'Payment List',
			merchant_management: 'Merchant Management',
			account: 'Account',
			setup: 'Setup',
		},
		merchant_list: 's List of franchises',
		account_number: 'Account number',
		qr_payment: {
			deal_name: 'Transaction name',
			title: 'QR Payment',
			payer: 'Payer',
			check_payment_information: 'Check the payment information.',
			payment: 'Payment',
			complete_payment: 'The payment has been completed.',
			payment_asset: 'Payment asset',
			payment_name: 'Payment name',
			amount: 'Payment amount',
		},
		payment_list: {
			login: 'Login',
			forgot: 'Find ID/password',
			qr_scan: 'Please scan the QR code.',
			merchant_selection: 'Select Merchant',
			count: ' thing',
			order_number: 'Order number',
			detail: {
				total_payment: 'Total',
				total_amount: 'Total Amount',
				complete_payment: 'Payment completed',
				refund: 'Refund',
				no_payment_count: '해당 날짜의 결제건이 없습니다.',
				merchant_name: 'Merchant Name',
				payment_assets: 'Payment Asset',
				payment_date: 'Payment Date',
				refund_date: 'Refund Date',
				check_refund_information: '환불 정보를 확인 해 주세요.',
				refund_complete: '환불이 완료되었습니다.',
			},
			table: {
				time: 'Payment Date',
				name: 'Payment Items',
				id: 'Payment ID',
				payer: 'Payer Name',
				type: 'Payment Type',
				status: 'Condition',
				amount: 'Payment Amount',
				oder_no: 'Store Order Number',
			},
			modal: {
				title: 'Detailed search',
				date1: 'Today',
				date2: 'Yesterday',
				date3: '1m',
				date4: '3m',
				date5: '6m',
			},
		},
		setup: {
			language: 'Language',
			terms: 'Terms',
			push_notification: 'Push alarm',
		},
	},
};
